import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { NzSwitchModule } from 'ng-zorro-antd/switch';

import { AlertsComponent } from '@app/client/alerts/components/alerts.component';
import { assertArray } from '@app/core/utilities/array.utilities';

@Component({
  selector: 'adspt-alerts-resolved-toggle',
  templateUrl: './alerts-resolved-toggle.component.html',
  styleUrls: ['./alerts-resolved-toggle.component.scss'],
  imports: [TranslateModule, NzSwitchModule, FormsModule, AsyncPipe],
})
export class AlertsResolvedToggleComponent {
  readonly showResolved$: Observable<boolean> = this.ac.alertFilterValues$.pipe(
    map((filterValues) => !filterValues?.cleared || assertArray(filterValues.cleared)?.includes(true)),
  );

  constructor(readonly ac: AlertsComponent) {}

  updateResolvedFilter(showResolved: boolean): void {
    this.ac.updateAlertFilters(this.ac.alertSource, { cleared: showResolved ? null : [false] });
  }
}
